import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getClientes,
  deleteCliente,
  getClienteById,
} from "../helpers/rutaClientes";
import ModalCliente from "./ModalCliente";

const COLS = {
  acciones: 90,
  nro: 60,
  razon: 180,       // ← ajustá acá los anchos que quieras
  domicilio: 140,
  telefono: 140,
  cuit: 140,
  email: 220,
  localidad: 160,
  contacto: 200,
  telContacto: 160,
  mailContacto: 220,
};

const cellTruncate = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const TableClientes = () => {
  const [state, setState] = useState({ clientes: [], loading: true, error: "" });
  const [cliente, setCliente] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaClientes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const consultaClientes = async () => {
    try {
      const datos = await getClientes();
      const lista =
        Array.isArray(datos?.clientes) ? datos.clientes :
        Array.isArray(datos)           ? datos :
        [];
      setState({ clientes: lista, loading: false, error: "" });
    } catch (e) {
      setState(s => ({ ...s, loading: false, error: e?.message || "Error al cargar clientes" }));
      console.error("❌ Error getClientes:", e);
    }
  };

  const handleClose = () => { setShow(false); consultaClientes(); };
  const handleShow  = () => setShow(true);

  const modificaCliente = (id) => {
    getClienteById(id)
      .then((resp) => {
        if (resp?.ok) { setCliente(resp.cliente); handleShow(); }
        else { console.error("❌ Error al obtener cliente:", resp?.error || resp); }
      })
      .catch(err => console.error("❌ Error getClienteById:", err));
  };

  const eliminarCliente = (id) => {
    if (window.confirm("¿Está seguro que desea borrar el cliente?")) {
      deleteCliente(id)
        .then(() => consultaClientes())
        .catch(err => console.error("❌ Error deleteCliente:", err));
    }
  };

  if (state.loading) return <div className="p-3">Cargando clientes…</div>;
  if (state.error)   return <div className="p-3 text-danger">{state.error}</div>;

  const rows = state.clientes.filter(c => c?.activo ?? true);

  return (
    <div className="table-container">
      <div className="col-12 mt-4" />
      <div>
        <Table
          striped
          bordered
          hover
          style={{ tableLayout: "fixed", width: "100%" }}  // ← fija anchos
        >
          <thead>
            <tr>
              <th style={{ width: COLS.acciones }}>Acciones</th>
              <th style={{ width: COLS.nro }}>Nro</th>
              <th style={{ width: COLS.razon }}>Razón Social</th>
              <th style={{ width: COLS.domicilio }}>Domicilio</th>
              <th style={{ width: COLS.telefono }}>Teléfono</th>
              <th style={{ width: COLS.cuit }}>CUIT</th>
              <th style={{ width: COLS.email }}>Email</th>
              <th style={{ width: COLS.localidad }}>Localidad</th>
              <th style={{ width: COLS.contacto }}>Contacto 1</th>
              <th style={{ width: COLS.telContacto }}>Teléfono Contacto 1</th>
              <th style={{ width: COLS.mailContacto }}>Email Contacto 1</th>
              <th style={{ width: COLS.contacto }}>Contacto 2</th>
              <th style={{ width: COLS.telContacto }}>Teléfono Contacto 2</th>
              <th style={{ width: COLS.mailContacto }}>Email Contacto 2</th>
            </tr>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={14} className="text-center">No hay clientes.</td>
              </tr>
            ) : (
              rows.map((c) => (
                <tr key={c._id || c.id}>
                  <td style={{ width: COLS.acciones, whiteSpace: "nowrap" }}>
                    <div style={{ display: "flex", gap: 8, flexWrap: "nowrap", justifyContent: "center" }}>
                      <button className="btn btn-primary" onClick={() => modificaCliente(c._id || c.id)}>
                        <i className="fa fa-pencil-square-o" aria-hidden="true" />
                      </button>
                      <button className="btn btn-danger" onClick={() => eliminarCliente(c._id || c.id)}>
                        <i className="fa fa-trash-o" aria-hidden="true" />
                      </button>
                    </div>
                  </td>

                  <td style={{ width: COLS.nro }}>{c.codcli}</td>
                  <td style={{ width: COLS.razon, textAlign: "left", ...cellTruncate }}>{c.razonsocial}</td>
                  <td style={{ width: COLS.domicilio, textAlign: "left", ...cellTruncate }}>{c.domicilio}</td>
                  <td style={{ width: COLS.telefono }}>{c.telefono}</td>
                  <td style={{ width: COLS.cuit }}>{c.cuit}</td>
                  <td style={{ width: COLS.email, ...cellTruncate }}>{c.email}</td>
                  <td style={{ width: COLS.localidad, ...cellTruncate }}>{c.localidad?.localidad || "-"}</td>
                  <td style={{ width: COLS.contacto, ...cellTruncate }}>{c.contacto1 || "-"}</td>
                  <td style={{ width: COLS.telContacto }}>{c.telefono1 || "-"}</td>
                  <td style={{ width: COLS.mailContacto, ...cellTruncate }}>{c.email1 || "-"}</td>
                  <td style={{ width: COLS.contacto, ...cellTruncate }}>{c.contacto2 || "-"}</td>
                  <td style={{ width: COLS.telContacto }}>{c.telefono2 || "-"}</td>
                  <td style={{ width: COLS.mailContacto, ...cellTruncate }}>{c.email2 || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      <ModalCliente show={show} handleClose={handleClose} cliente={cliente} />
    </div>
  );
};

export default TableClientes;
